/* Step-3 ("Complete Your Ring", URL contains ?view=final-ring) and /cart page
   breadcrumb override. Rebuilds the trail from the actual setting + diamond
   the shopper chose during the builder, instead of the setting product's
   default collection breadcrumb (which was showing the unrelated parent
   collection title). */
(function(){
  function getCk(n){ var m = document.cookie.match(new RegExp('(^| )' + n + '=([^;]+)')); return m ? decodeURIComponent(m[2]) : null; }
  function readJson(n){ var r = getCk(n); if (!r) return null; try { return JSON.parse(r); } catch(e){ return null; } }
  function esc(s){ return (s==null?'':String(s)).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }

  var DIVIDER = '<span class="breadcrumb__divider" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" class="mx-2"><path d="M4.50003 9L7.5 5.99998L4.5 3" stroke="black" stroke-width="1.5" stroke-miterlimit="16" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

  function rebuild(){
    var nav = document.querySelector('.BGBreadcrumb_Spine nav.breadcrumb');
    if (!nav) return;

    var isFinal = /[?&]view=final-ring/.test(location.search);
    var isCart  = /^\/cart(\/|$|\?)/.test(location.pathname);
    if (!isFinal && !isCart) return;

    var html = '<a href="/" title="Home">Home</a>';

    if (isFinal) {
      // Step 3 simplification: the 3-step stepper directly above the breadcrumb
      // already shows the funnel (1 STONE → 2 SETTING → 3 RING) with the picked
      // setting + diamond labels. Repeating that in the breadcrumb is noise.
      // Keep the breadcrumb to just: Home › Complete Your Ring.
      html += DIVIDER + '<span aria-current="page">Complete Your Ring</span>';
    } else if (isCart) {
      html += DIVIDER + '<span aria-current="page">Cart</span>';
    }

    nav.innerHTML = html;
  }

  function setupMobileCollapse() {
    var nav = document.querySelector('.BGBreadcrumb_Spine nav.breadcrumb');
    if (!nav) return;

    // Clear prior markers (in case rebuild() ran first)
    Array.prototype.forEach.call(nav.querySelectorAll('.bc-current'), function(el){
      el.classList.remove('bc-current');
    });

    // The current-page crumb is preferentially the <span aria-current="page">.
    // Fallback: the last non-divider/script/button/hide child.
    var current = nav.querySelector('span[aria-current="page"]');
    if (!current) {
      var kids = Array.prototype.filter.call(nav.children, function(c){
        return !c.classList.contains('breadcrumb__divider')
            && !c.classList.contains('hide')
            && c.tagName !== 'SCRIPT'
            && c.tagName !== 'BUTTON';
      });
      current = kids[kids.length - 1];
    }
    if (!current) return;
    current.classList.add('bc-current');

    // Insert / refresh the "…" expand toggle BEFORE the current crumb so the
    // collapsed visible order reads "… › Current Page".
    var existing = nav.querySelector('.bc-expand-toggle');
    if (existing) existing.remove();
    // Only worth inserting if there's more than one anchor on this page
    var anchorsCount = nav.querySelectorAll('a:not(.hide)').length;
    if (anchorsCount < 1) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bc-expand-toggle';
    btn.textContent = '…';
    btn.setAttribute('aria-label', 'Show full breadcrumb');
    btn.addEventListener('click', function(){
      var expanded = nav.classList.toggle('bc-expanded');
      btn.textContent = expanded ? '✕' : '…';
      btn.setAttribute('aria-label', expanded ? 'Collapse breadcrumb' : 'Show full breadcrumb');
    });
    nav.insertBefore(btn, current);
  }

  function init() {
    rebuild();
    setupMobileCollapse();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-run on full load so H1 (sometimes hydrated post-DOMContentLoaded by JS)
  // is available for the Step 3 title-extraction fallback.
  window.addEventListener('load', init);
})();
